import React from "react";
import {TextButton} from "js/common/views/inputs/buttons";
import * as Users from "js/common/users";
import * as Permissions from "js/common/permissions";

const TargetsButtons = ({
  viewType,
  targets,
  isSaving,
  hasUnsavedChanges,
  onCancel,
  onEdit,
  onSave,
  onAdd
}) => {
  const buttonStyle = {marginBottom: 0, marginLeft: "0.5rem", marginRight: "0.5rem"};
  const currentUser = Users.getCurrentUser();
  const showTargetAdminButtons = Users.canAccessApp(currentUser, Permissions.apps.targetAdmin)
      && viewType === "SIMPLE";

  return (
      <div style={{margin: "1rem"}}>
        {(!targets.isEmpty() && showTargetAdminButtons) && (
            <TextButton
                type="secondary"
                icon="pencil"
                label="Edit Targets"
                onClick={onEdit}
                style={buttonStyle} />)}

        {viewType === "EDIT" && (
            <>
              <TextButton
                  type="secondary"
                  icon="history"
                  label="Cancel Changes"
                  onClick={onCancel}
                  style={buttonStyle} />
              <TextButton
                  type="primary"
                  icon={isSaving ? "spinner fa-spin" : "floppy-o"}
                  label="Save Changes"
                  onClick={onSave}
                  disabled={!hasUnsavedChanges}
                  style={buttonStyle} />
            </>)}

        {showTargetAdminButtons && (
            <TextButton
                type="primary"
                icon="plus"
                label="Add New Target"
                onClick={onAdd}
                style={buttonStyle}
            />)}
      </div>);
};

export default TargetsButtons;